import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { FormGroup, FormControl } from '@angular/forms';
import { GridDataResult, PageChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription,Observable } from 'rxjs';
import { RefreshToken } from '@app/cp/shared/models/RefreshToken';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
//import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import * as _ from 'lodash';

import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { MSCLFilterClass } from '../../../shared/classes/filters/MSCLFilterClass';
@Component({
    selector: 'profit-analysis-landing',
    templateUrl: './profit-analysis-landing.component.html',
    styleUrls: ['./profit-analysis-landing.component.scss'],
    standalone: false
})
export class ProfitAnalysisLandingComponent implements OnInit, OnDestroy {

    constructor(private globals: GlobalsService, private svc_construction: ConstructionService, private svc_dispatch: DispatchesService) {

        this.allData = this.allData.bind(this);
    }
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    jobTypeCF: MSCLFilterClass;
    costSourceCF: MSCLFilterClass;
    costTypeCF: MSCLFilterClass;
    detNameCF: MSCLFilterClass;
    detDescCF: MSCLFilterClass;
    readOnly: boolean = false;

    @Input() contractId: string;
    @Input() jobId: string;

    detailOpen: boolean = false;

    responseData: BaseMessageInfo;
    paData: BaseMessageInfo;
    pwData: BaseMessageInfo;
    rData: BaseMessageInfo;
    cData: BaseMessageInfo;
    eData: BaseMessageInfo;
    mData: BaseMessageInfo;
    subJobs: any[] = [];
    subJobData: any[] = [];
    totData: BaseMessageInfo;
    jobData: BaseMessageInfo;
    detailData: any;
    originalData: any;
    groupedData: any;
    totals: any;
    costDetailData: GridDataResult;
    pageSize = 20;
    skip = 0;

    loading: boolean = true;

    isMaster: boolean;
    @ViewChild('grid') protected grid: GridComponent;
    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    refreshSubs: Subscription;
    refreshData(token: RefreshToken) {

        if (token.all) {
            this.getData();
        }
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.refreshSubs);
    }
    ngOnInit() {
        this.getData();

        if (this.svc_construction) {
            this.refreshSubs = this.svc_construction.refreshSubject.subscribe((token: RefreshToken) => {
                this.refreshData(token);
            });
        }
    }
    public loadData() {

        this.ngOnInit();
    }
    clearData() {
        this.responseData = null;
        this.paData = null;
        this.pwData = null;
        this.subJobs = [];
        this.subJobData = [];
        this.totData = null;
        this.jobData = null;
        this.detailData = null;
    }
    getData() {
        this.clearData();
        if (this.contractId) {
            if (this.totData && this.totData.primaryReturn) { this.totData.primaryReturn = null; }

            this.constSearchParam.contractId = this.jobId;
            //alert('jobId: ' + this.jobId);
            //alert('contractId: ' + this.contractId);
            this.svc_construction.getConstProfitAnalysis(this.constSearchParam).subscribe(data => {
                this.responseData = data;
                this.isMaster = this.responseData.primaryReturn.isMaster;

                //this.setForm();
                this.svc_construction.GetCostDetailsByContractId(this.constSearchParam).subscribe(data => {
                    this.detailData = data.primaryReturn;
                    this.originalData = _.cloneDeep(this.detailData);
                    if (this.detailData) {
                        this.processGridData();
                    }

                });
                if (this.isMaster == true) {
                    this.svc_construction.GetSubJobList(this.constSearchParam).subscribe(data => {
                        this.subJobs = data.primaryReturn;
                        console.log('subjobs: ' + JSON.stringify(this.subJobs));
                        this.subJobs.forEach(subJob => {
                            console.log('SubJob: ' + subJob.jobId);
                            this.svc_construction.GetProfitAnalysisByJobId(this.constSearchParam, subJob.jobId).subscribe(data => {
                                let temp = data.primaryReturn;

                                temp.type = subJob.type;
                                this.subJobData.push(temp);

                                this.addToTotals(data);
                            });
                        });
                    });
                    //Get PW data
                    if (Object.keys(this.responseData.primaryReturn).length > 0) {
                        this.svc_construction.GetPostWarrantyByContractId(this.constSearchParam).subscribe(data => {
                            this.pwData = data;

                        });
                    }

                } else {
                    //Sub Job
                    this.svc_construction.GetProfitAnalysisByJobId(this.constSearchParam, this.jobId).subscribe(data => {
                        this.jobData = data;
                    });
                }

                if (this.responseData.warning) {
                    //alert('got an error back!');
                }
            });
        }

    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.detailData = filterBy(this.originalData, filter);
        this.processGridData();
    }
    openDetails() {
        this.detailOpen = true;
    }
    closeDetails() {
        this.detailOpen = false;
    }
    pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadItems();
    }

    private loadItems(): void {
        this.costDetailData = {
            data: this.detailData.slice(this.skip, this.skip + this.pageSize),
            total: this.detailData.length
        };

    }

    addToTotals(newData: BaseMessageInfo) {
        if (this.totData != null) {
            this.totData.primaryReturn.lab = this.totData.primaryReturn.lab + newData.primaryReturn.lab;
            this.totData.primaryReturn.mat = this.totData.primaryReturn.mat + newData.primaryReturn.mat;
            this.totData.primaryReturn.other = this.totData.primaryReturn.other + newData.primaryReturn.other;
            this.totData.primaryReturn.matVC = this.totData.primaryReturn.matVC + newData.primaryReturn.matVC;
            this.totData.primaryReturn.othVC = this.totData.primaryReturn.othVC + newData.primaryReturn.othVC;
            this.totData.primaryReturn.labMfgWrnty = this.totData.primaryReturn.labMfgWrnty + newData.primaryReturn.labMfgWrnty;
            this.totData.primaryReturn.taxRate = newData.primaryReturn.taxRate;
            this.totData.primaryReturn.labTax = this.totData.primaryReturn.labTax + newData.primaryReturn.labTax;
            this.totData.primaryReturn.matTax = this.totData.primaryReturn.matTax + newData.primaryReturn.matTax;
            this.totData.primaryReturn.othTax = this.totData.primaryReturn.othTax + newData.primaryReturn.othTax;
            this.totData.primaryReturn.contractAmt = this.totData.primaryReturn.contractAmt + newData.primaryReturn.contractAmt;
            this.totData.primaryReturn.bidWarranty = this.totData.primaryReturn.bidWarranty + newData.primaryReturn.bidWarranty;
            this.totData.primaryReturn.acceptedBidAmt = this.totData.primaryReturn.acceptedBidAmt + newData.primaryReturn.acceptedBidAmt;
            this.totData.primaryReturn.bidEstCost = this.totData.primaryReturn.bidEstCost + newData.primaryReturn.bidEstCost;
            this.totData.primaryReturn.salesTax = this.totData.primaryReturn.salesTax + newData.primaryReturn.salesTax;

        }
        else {
            this.totData = JSON.parse(JSON.stringify(newData));
        }

    }
    public onSplitButtonClick(e: string): void {

        if (e === "Pdf") {
            this.exportGridToExcel();
        }
        else {
            this.exportGridToExcel();
        }
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.detailData) this.detailData = [];
        const result: ExcelExportData = {
            data: process(this.detailData as any , {}).data,
        };
        return result;
    }

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    processGridData() {
        //if (CommonFunctions.hasArrayElementValue(this.gridData)) {
        //    this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        //}
        this.jobTypeCF = new MSCLFilterClass('relatedJobType', 'relatedJobType', this.detailData);
        this.costSourceCF = new MSCLFilterClass('costSource', 'costSource', this.detailData);
        this.costTypeCF = new MSCLFilterClass('costType', 'costType', this.detailData);
        this.detNameCF = new MSCLFilterClass('detName', 'detName', this.detailData);
        this.detDescCF = new MSCLFilterClass('detDesc', 'detDesc', this.detailData);

        this.totals = [];
        this.detailData.forEach((element) => {
            var i = this.totals.findIndex(x => x.costType === element.costType);
            if (i >= 0) {
                var ii = this.totals[i].relatedJobTypes.findIndex(x => x.relatedJobType === element.relatedJobType);
                if (ii >= 0) {
                    this.totals[i].relatedJobTypes[ii].totalCost = this.totals[i].relatedJobTypes[ii].totalCost + element.totalCost;
                    this.totals[i].totalCost = this.totals[i].totalCost + element.totalCost;
                } else {
                    this.totals[i].totalCost = this.totals[i].totalCost + element.totalCost;
                    this.totals[i].relatedJobTypes.push({ relatedJobType: element.relatedJobType, totalCost: element.totalCost });
                    this.totals[i].relatedJobTypes.sort(function (a, b) {
                        var nameA = a.relatedJobType.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.relatedJobType.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        // names must be equal
                        return 0;
                    });
                }
            }
            else {
                this.totals.push({ costType: element.costType, totalCost: element.totalCost, relatedJobTypes: [{ relatedJobType: element.relatedJobType, totalCost: element.totalCost }] })
                this.totals.sort(function (a, b) {
                    var nameA = a.costType.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.costType.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                });
            }
        });
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public filter: CompositeFilterDescriptor;

    test() {

        (
            (
                this.responseData.primaryReturn.newContractValue
              + this.responseData.primaryReturn.pendingChangeOrdersValue
                    - (
                        this.responseData.primaryReturn.changeOrderPassThru
                      + this.responseData.primaryReturn.pendingChangeOrderPassThru
                      )
            )
            -
            (
                (
                    (
                        this.totData.primaryReturn.lab
                      - this.totData.primaryReturn.labMfgWrnty
                      + this.totData.primaryReturn.labTax
                    )
                    +
                    (
                        this.totData.primaryReturn.mat
                      - this.totData.primaryReturn.matVC
                      + this.totData.primaryReturn.matTax
                    )
                    +
                    (
                        this.totData.primaryReturn.other
                      - this.totData.primaryReturn.othVC
                      + this.totData.primaryReturn.othTax
                    )
                    +
                    (
                        this.totData.primaryReturn.salesTax
                    )
                    +
                    (
                        this.totData.primaryReturn.bidWarranty
                    )
                )
                -
                (
                    this.responseData.primaryReturn.changeOrderPassThru
                  + this.responseData.primaryReturn.pendingChangeOrderPassThru
                )
            )
        )

    }
    showCalcDetail: boolean = false;
    openCalcDetail() {
        this.showCalcDetail = true;
    }
    closeCalcDetail() {
        this.showCalcDetail = false;
    }

}
